import MuiAppBar, {
    AppBarProps as MuiAppBarProps,
    AppBarClassKey as MuiAppBarClassKey
} from "@material-ui/core/AppBar";

export type AppBarClassKey = MuiAppBarClassKey;
export type AppBarProps = MuiAppBarProps;

export default MuiAppBar;